import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    loadingGrid: { justifyContent: 'center' },
    headerLabels: {
      width: 180,
      alignItems: 'baseline',
      display: 'flex',
      flexWrap: 'wrap-reverse',
      textAlign: 'end',
      alignContent: 'baseline',
    },
    headerLabelsVersion: {
      width: 180,
      height: '100%',
      alignItems: 'center',
      display: 'flex',
      cursor: 'pointer',
      justifyContent: 'center',
      textAlign: 'end',
      alignContent: 'baseline',
      borderTop: `0.8px solid ${palette.sideGrayLighter}`,
      borderBottom: `0.8px solid ${palette.sideGrayLighter}`,
      borderLeft: `0.8px solid ${palette.sideGrayLighter}`,
    },
    headerLabelsVersionError: { backgroundColor: palette.superLightRed },
    headerLabelsText: { width: '100%', marginRight: 12 },
    stepsGrid: { width: '88%' },
    stepsGridModal: { width: '88%' },
    buttonsGrid: { width: '10%' },
    headerInfos: {
      width: 'calc(100% - 180px)',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
    },
    infoItem: {
      flexGrow: 1,
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      border: `0.8px solid ${palette.sideGrayLighter}`,
      width: 0,
    },
    infoItemError: {
      flexGrow: 1,
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      border: `0.8px solid ${palette.sideGrayLighter}`,
      width: 0,
      fontWeight: 500,
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: palette.lightRed,
      fontSize: 14,
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundImage:
          'linear-gradient(-45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent)',
        zIndex: 1,
        backgroundSize: '50px 50px',
        overflow: 'hidden',
      },
    },
    stepName: {
      flex: 1,
      width: '100%',
      display: 'flex',
      padding: '16px 4px',
      alignItems: 'center',
      borderBottom: `1px solid ${palette.logsGray}`,
      justifyContent: 'center',
      maxHeight: 55,
      height: 55,
      minHeight: 55,
    },
    stepDurationHeader: {
      width: '100%',
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center',
      flex: 1,
      padding: '6px 0px',
      backgroundColor: palette.greyCardBorder,
    },
    stepDuration: {
      width: '100%',
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center',
      padding: '17px 0px',
      flex: 1,
      transition: 'all 0.3s ease',
    },
    stepDurationSuccess: {
      cursor: 'pointer',
      width: '100%',
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center',
      padding: '17px 0px',
      flex: 1,
      backgroundColor: `${palette.lightGreen} !important`,
    },
    stepDurationWarning: {
      width: '100%',
      cursor: 'pointer',
      height: '100%',
      fontWeight: 500,
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: palette.superLightYellow,
      padding: '17px 0px 0px 0px !important',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      fontSize: 14,
      display: 'flex',
    },
    stepDurationError: {
      width: '100%',
      cursor: 'pointer',
      height: '100%',
      fontWeight: 500,
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: palette.lightRed,
      padding: '17px 0px 0px 0px !important',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      fontSize: 14,
      display: 'flex',
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundImage:
          'linear-gradient(-45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent)',
        zIndex: 1,
        backgroundSize: '50px 50px',
        overflow: 'hidden',
      },
    },
    stepDurationSkipped: {
      width: '100%',
      cursor: 'pointer',
      height: '100%',
      fontWeight: 500,
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: palette.superLightGreen,
      padding: '17px 0px 0px 0px !important',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      fontSize: 14,
      display: 'flex',
    },
    stepDurationRunning: {
      width: '100%',
      zIndex: 2,
      height: '100%',
      fontWeight: 500,
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: palette.logsBlue,
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: 14,
      display: 'flex',
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundImage:
          'linear-gradient(-45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent)',
        zIndex: 1,
        backgroundSize: '50px 50px',
        animation: '$move 2s linear infinite',
        overflow: 'hidden',
      },
    },

    breakText: {
      wordWrap: 'break-word',
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
    },
    stepNameTypo: {
      fontWeight: 500,
      fontSize: 12,
      textAlign: 'center',
    },
    stepDurationTypo: {
      fontWeight: 500,
      fontSize: 12,
      zIndex: 2,
      color: palette.darkGreen,
      transition: 'opacity 0.3s ease',
    },
    stepDurationTypoOpacity: { opacity: 1 },
    stepDurationTypoNoOpacity: { opacity: 0 },
    stepDurationTypoHeader: {
      fontWeight: 400,
      fontSize: 12,
      zIndex: 2,
    },
    stepDurationTypoError: {
      fontWeight: 500,
      fontSize: 12,
      zIndex: 2,
      color: palette.darkRed,
    },
    stepDurationTypoRunning: {
      fontWeight: 500,
      fontSize: 12,
      zIndex: 2,
      color: palette.blue,
      position: 'relative',
    },
    headerLabelsTextTypo: { fontSize: 12, fontWeight: 400 },
    headerLabelsTextTypoInfo: {
      fontSize: 9,
      fontWeight: 400,
      lineHeight: '14px',
    },
    startedAtBox: {
      padding: 6,
      margin: '8px 0px',
      borderRadius: 8,
      backgroundColor: palette.white,
      boxShadow:
        'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
    },
    headerLabelsTextTypoStarted: { fontSize: 14, fontWeight: 400 },
    headerLabelsTextTypoErrorChip: {
      fontSize: 10,
      fontWeight: 500,
      marginRight: 8,
      border: `0.8px solid ${palette.red}`,
      borderRadius: 20,
      padding: '0px 4px',
      lineHeight: '12px',
      color: palette.white,
      backgroundColor: palette.red,
    },
    headerLabelsTextTypoSuccessChip: {
      fontSize: 10,
      fontWeight: 500,
      marginRight: 8,
      border: `0.8px solid ${palette.status.success}`,
      borderRadius: 20,
      padding: '0px 4px',
      lineHeight: '12px',
      color: palette.white,
      backgroundColor: palette.status.success,
    },
    headerLabelsTextTypoRunningChip: {
      fontSize: 10,
      fontWeight: 500,
      marginRight: 8,
      border: `0.8px solid ${palette.blue}`,
      borderRadius: 20,
      padding: '0px 4px',
      lineHeight: '12px',
      color: palette.white,
      backgroundColor: palette.blue,
    },
    headerLabelsTextTypoWarningChip: {
      fontSize: 10,
      fontWeight: 500,
      marginRight: 8,
      border: `0.8px solid ${palette.darkYellow}`,
      borderRadius: 20,
      padding: '0px 4px',
      lineHeight: '12px',
      color: palette.white,
      backgroundColor: palette.darkYellow,
    },
    infoIcon: {
      color: palette.grey500,
      fontSize: 16,
      marginLeft: 8,
      cursor: 'pointer',
    },
    progress: {
      padding: 6,
      background: 'rgba(0, 0, 0, 0.25)',
      borderRadius: 6,
      boxShadow:
        'inset 0 1px 2px rgba(0, 0, 0, 0.25), 0 1px rgba(255, 255, 255, 0.08)',
    },
    barProgress: {
      width: '100%',
      height: 54,
    },
    barText: {
      width: '100%',
      zIndex: 2,
      height: '100%',
      fontWeight: 500,
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: palette.logsGreen,
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: 14,
      display: 'flex',
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundImage:
          'linear-gradient(-45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent)',
        zIndex: 1,
        backgroundSize: '50px 50px',
        animation: '$move 2s linear infinite',
        overflow: 'hidden',
      },
    },
    '@keyframes move': {
      '0%': {
        backgroundPosition: '0 0',
      },
      '100%': {
        backgroundPosition: '50px 50px',
      },
    },
    errorLabelBox: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
      zIndex: 2,
    },
    failedTextBox: {
      fontSize: 9,
      color: palette.darkRed,
      fontWeight: 500,
      marginRight: 4,
    },
    warningTextBox: {
      fontSize: 9,
      color: palette.darkYellow,
      fontWeight: 500,
      marginRight: 4,
    },
    skippedTextBox: {
      fontSize: 9,
      color: palette.darkGreen,
      fontWeight: 500,
      marginRight: 6,
    },
    logsCell: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      zIndex: 2,
    },
    valid: {
      color: palette.green,
      fontSize: 14,
    },
    invalid: {
      color: palette.red,
      fontSize: 14,
    },
    warning: {
      color: palette.darkYellow,
      fontSize: 14,
    },
    skipped: {
      color: palette.grey800,
      fontSize: 14,
    },
    statusSkipped: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: palette.logsLightGray,
      padding: '4px 12px',
      borderRadius: 16,
    },
    statusIconSkipped: {
      fontSize: 16,
      marginRight: 6,
      color: palette.grey800,
    },
    running: {
      color: palette.blue,
      fontSize: 14,
    },
    statusRunning: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: palette.logsLightBlue,
      padding: '4px 12px',
      borderRadius: 16,
    },
    statusIconRunning: {
      fontSize: 16,
      marginRight: 6,
      color: palette.blue,
    },
    statusValid: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: palette.backgroundLightGreen,
      padding: '4px 12px',
      borderRadius: 16,
    },
    statusInvalid: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: palette.backgroundSuperLightRed,
      padding: '4px 12px',
      borderRadius: 16,
    },
    statusIconValid: {
      fontSize: 16,
      marginRight: 6,
      color: palette.status.success,
    },
    statusIconInvalid: {
      fontSize: 16,
      marginRight: 6,
      color: palette.red,
    },
    statusWarning: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: palette.superLightYellow,
      padding: '4px 12px',
      borderRadius: 16,
    },
    statusIconWarning: {
      fontSize: 16,
      marginRight: 6,
      color: palette.darkYellow,
    },
    renderStatus: { margin: '8px 0px 24px 0px' },
    itemInfoDetail: {
      display: 'flex',
    },
    infoTitle: {
      fontSize: 12,
      color: palette.darkGray,
      display: 'flex',
      fontWeight: 500,
      marginRight: 8,
    },
    infoValue: {
      fontSize: 12,
      wordBreak: 'break-word',
    },
    equalizerIcon: {
      transition: 'opacity 0.3s ease',
      opacity: 1,
      fontSize: 16,
      color: palette.grey700,
      marginLeft: 4,
    },
    seeDetails: {
      transition: 'opacity 0.3s ease',
      opacity: 1,
      fontSize: 12,
      color: palette.grey700,
    },
    modalHeaderInfo: { display: 'block', marginBottom: 4 },
    modalHeaderInfoSection: { display: 'block', padding: 6 },
    modalBodyInfo: { display: 'block' },
    modalBodyTitle: {
      padding: 4,
      borderRadius: 8,
      margin: '6px 0px',
      display: 'block',
      alignItems: 'center',
      cursor: 'pointer',
    },
    modalBodyTitleSuccess: {
      backgroundColor: palette.logsLightGreen,
      boxShadow:
        'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
    },
    modalBodyTitleError: {
      backgroundColor: palette.logsLightRed,
      boxShadow:
        'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
    },
    modalBodyTitleSkipped: {
      backgroundColor: palette.logsLightGray,
      boxShadow:
        'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
    },
    modalBodyTitleRunning: {
      backgroundColor: palette.logsLightBlue,
      boxShadow:
        'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
    },
    modalBodyTitleWarning: {
      backgroundColor: palette.logsLightYellow,
      boxShadow:
        'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
    },
    modalBodyTitleValue: {
      fontSize: 12,
      marginLeft: 4,
      color: palette.grey800,
    },
    detailExpandGrid: { display: 'flex', alignItems: 'center' },
    modelVersionGrid: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '12%',
    },
    modelVersionGridModal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '12%',
    },
    expandIcon: { color: palette.grey800, fontSize: 20 },
    modalBodyTitleStatus: {
      fontSize: 12,
      fontWeight: 500,
      marginRight: 6,
    },
    modalBodyTitleStatusSuccess: {
      color: palette.green,
    },
    modalBodyTitleStatusError: {
      color: palette.red,
    },
    modalBodyTitleStatusRunning: {
      color: palette.blue,
    },
    modalBodyTitleStatusSkipped: {
      color: palette.grey800,
    },
    modalBodyTitleStatusWarning: {
      color: palette.darkYellow,
    },
    infoGridIcon: { marginRight: -18, zIndex: 2, marginTop: -28 },
    modelVersionText: {
      padding: '4px 8px',
      fontSize: 10,
      fontWeight: 500,
      boxShadow:
        'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
      borderRadius: 12,
      cursor: 'pointer',
    },
    modelModalVersionText: {
      cursor: 'default',
      boxShadow: 'unset',
      border: `1px solid ${palette.grey200}`,
      textAlign: 'center',
      margin: '0px 4px',
    },
    modelVersionTextUnavailable: {
      padding: '4px 8px',
      fontSize: 10,
      fontWeight: 500,
      borderRadius: 12,
      backgroundColor: palette.grey200,
      color: palette.grey600,
    },
    container: {
      boxShadow:
        'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
      borderRadius: 8,
    },
    inProgress: { fontSize: 14, marginLeft: 8 },
    redoIcon: { fontSize: 14 },
    backButton: {
      color: `${palette.blue} !important`,
      borderColor: `${palette.blue} !important`,
    },
    alert: {
      width: 'fit-content',
      margin: 32,
      fontSize: 12,

      '& b': {
        fontWeight: 900,
      },
    },
    alertText: { fontSize: 14 },
  });

export const overrideModal = {
  content: {
    padding: 12,
    fontSize: '12px !important',
    maxHeight: '100%',
    maxWidth: 600,
    overflowX: 'auto',
  },
};
